import type { DeckConfigEntry } from 'src/components/star-grid/deckConfig.types';
import { PNL_ACTUALS_SCENARIO_ID } from 'src/components/star-grid/starGridConstants';
import { PnlPivotCalcColumn, PnlPivotColumnGroup, PnlScenarioEntry, PnlVariancePair } from 'src/components/star-grid/starGridTypes';

import { deckPeriodType } from 'src/components/star-grid/utils/pnlPeriodLabels';

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const formatMonthShort = (month: number): string => `${MONTH_NAMES[(month % 100) - 1]} ${String(Math.floor(month / 100)).slice(-2)}`;
export const pivotFieldId = (scenario: number, month: number): string => `s${scenario}_m${month}`;
export const effectiveScenarioId = (scenario: PnlScenarioEntry, month: number): number =>
  scenario.forecast_start_period && month < scenario.forecast_start_period ? PNL_ACTUALS_SCENARIO_ID : scenario.reporting_scenario_id;

const varianceColumn = (
  pair: PnlVariancePair,
  month: number,
  index: number,
  pairIndex: number,
  scenarios: readonly PnlScenarioEntry[]
): PnlPivotCalcColumn[] => {
  const compareMonth = pair.compare_months[index];
  const base = scenarios.find((scenario) => scenario.label === pair.base_scenario && scenario.months.includes(month));
  const compare = scenarios.find((scenario) => scenario.label === pair.compare_scenario && scenario.months.includes(compareMonth));
  if (!base || !compare) return [];
  return [
    {
      colId: `variance_${pairIndex}_${index}`,
      headerName: month === compareMonth ? formatMonthShort(month) : `${formatMonthShort(month)} vs ${formatMonthShort(compareMonth)}`,
      expression: `[${pivotFieldId(effectiveScenarioId(base, month), month)}] - [${pivotFieldId(
        effectiveScenarioId(compare, compareMonth),
        compareMonth
      )}]`,
      group: `${pair.base_scenario} vs ${pair.compare_scenario}`
    }
  ];
};
